/**
 * Get the featured image for a publication with fallback chain:
 * 1. Explicitly uploaded featured image
 * 2. First image found in publication content
 *
 * @param featuredImageUrl - Explicitly set featured image URL
 * @param contentHtml - Publication HTML content for extracting inline images
 * @returns The best available image URL, or undefined if none found
 */
export function getPublicationFeaturedImage(
  featuredImageUrl: string | null | undefined,
  contentHtml?: string | null | undefined
): string | undefined {
  // 1. Explicit featured image
  if (featuredImageUrl) return featuredImageUrl;
  
  // 2. First image from content HTML
  if (contentHtml) {
    const imgMatch = contentHtml.match(/<img[^>]+src=["']([^"']+)["']/i);
    if (imgMatch?.[1]) return imgMatch[1];
  }
  
  return undefined;
}

/**
 * Extract the first image URL from HTML content
 */
export function extractFirstContentImage(contentHtml: string | null | undefined): string | undefined {
  if (!contentHtml) return undefined;
  const imgMatch = contentHtml.match(/<img[^>]+src=["']([^"']+)["']/i);
  return imgMatch?.[1];
}
